// src/hooks/useVenueTheme.js
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// Predefiniowane motywy – teraz tylko kolory HEX + nazwa
export const colorThemes = {
  emeraldRoyal: {
    name: "Szmaragd Królewski",
    primary: "#0F766E",    // teal-700
    secondary: "#115E59",  // ciemniejszy teal
    accent: "#065F46",     // bg-dark
    ring: "#0F766E",
  },
  navyElegant: {
    name: "Granat Elegancki",
    primary: "#1E293B",    // slate-800
    secondary: "#0F172A",  // slate-900
    accent: "#020617",
    ring: "#1E293B",
  },
  goldBanquet: {
    name: "Złoto Bankietowe",
    primary: "#b5933b",
    secondary: "#9e7f2f",
    accent: "#7c6224",
    ring: "#b5933b",
  },
  graphiteModern: {
    name: "Grafit Nowoczesny",
    primary: "#262626",
    secondary: "#171717",
    accent: "#000000",
    ring: "#262626",
  },
  burgundyPrestige: {
    name: "Burgund Prestige",
    primary: "#6D1A36",
    secondary: "#58142B",
    accent: "#4A1024",
    ring: "#6D1A36",
  },
  midnightBlue: {
    name: "Midnight Blue",
    primary: "#0A2540",
    secondary: "#081F33",
    accent: "#051827",
    ring: "#0A2540",
  },
  royalPurple: {
    name: "Purpura Królewska",
    primary: "#4C1D95",
    secondary: "#3B1775",
    accent: "#2E1065",
    ring: "#4C1D95",
  },
  sandStone: {
    name: "Piaskowiec",
    primary: "#C2B280",
    secondary: "#AFA06E",
    accent: "#6F5F3E",
    ring: "#C2B280",
  },
  blackGoldElite: {
    name: "Black Gold Elite",
    primary: "#0F0F0F",
    secondary: "#1A1A1A",
    accent: "#C9A24D",
    ring: "#C9A24D",
  },
};

export function useVenueTheme(venueName) {
  const [theme, setTheme] = useState({
    name: colorThemes.emeraldRoyal.name,
    primary: colorThemes.emeraldRoyal.primary,
    secondary: colorThemes.emeraldRoyal.secondary,
    accent: colorThemes.emeraldRoyal.accent,
    ring: colorThemes.emeraldRoyal.ring,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!venueName) {
      setTheme({
        name: colorThemes.emeraldRoyal.name,
        primary: colorThemes.emeraldRoyal.primary,
        secondary: colorThemes.emeraldRoyal.secondary,
        accent: colorThemes.emeraldRoyal.accent,
        ring: colorThemes.emeraldRoyal.ring,
      });
      setLoading(false);
      return;
    }

    const fetchTheme = async () => {
      try {
        const chosenRef = doc(db, "venues", venueName, "defaults", "chosen");
        const snap = await getDoc(chosenRef);

        if (snap.exists() && snap.data()?.color && colorThemes[snap.data().color]) {
          const selected = colorThemes[snap.data().color];
          setTheme({
            name: selected.name,
            primary: selected.primary,
            secondary: selected.secondary,
            accent: selected.accent,
            ring: selected.ring,
          });
        } else {
          // Fallback na szmaragdowy
          const fallback = colorThemes.emeraldRoyal;
          setTheme({
            name: fallback.name,
            primary: fallback.primary,
            secondary: fallback.secondary,
            accent: fallback.accent,
            ring: fallback.ring,
          });
        }
      } catch (error) {
        console.error("Błąd pobierania motywu:", error);
        // Fallback nawet przy błędzie sieci
        const fallback = colorThemes.emeraldRoyal;
        setTheme({
          name: fallback.name,
          primary: fallback.primary,
          secondary: fallback.secondary,
          accent: fallback.accent,
          ring: fallback.ring,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchTheme();
  }, [venueName]);

  return { theme, loading };
}